import { Button, Modal } from 'rsuite';
import RoomsSlider from 'components/LandingPageCarousels/RoomsSlider';
import Styles from './styles.js';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { UserApi } from 'services/api';

function WinnipegModal({ show, setClose, dataModal }) {
  const [width, setWidth] = useState(null);

  useEffect(() => {
    // only execute all the code below in client side
    if (typeof window !== 'undefined') {
      // Handler to call on window resize

      const handleResize = () => {
        setWidth(window.innerWidth);
      };

      window.addEventListener('resize', handleResize);
      handleResize();

      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);
  const onCancelClick = () => {
    UserApi.updateCurrentUser({ seenWelcomeModal: true });
  };

  return (
    <>
      <Modal
        dialogClassName="roomModal"
        backdropClassName="roomModalMobile"
        sss
        backdrop={'static'}
        show={show}
        onHide={() => setClose(false)}
        size={width < 600 ? 'xs' : width < 800 ? 'sm' : width < 1024 ? 'md' : 'lg'}>
        <Modal.Body>
          <RoomsSlider
            hideThumbnails={true}
            imageSource={dataModal}
            titleOne="FLOOR PLANS AND FURNITURE LIST"
            bg="white"
          />
        </Modal.Body>
        <Modal.Footer style={{ textAlign: 'center', marginTop: '1em' }}>
          <Button
            onClick={() => {
              onCancelClick();
              setClose(false);
            }}
            size="xs"
            appearance="ghost">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Styles/>
    </>
  );
}

WinnipegModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setClose: PropTypes.func.isRequired,
};

export default WinnipegModal;
